import { RFIMS_SITES } from './registry';
import type { Antenna, NetworkDataset } from '../loader/types';
import { RFIMS_MODEL_PLACEMENTS } from './modelPlacement';

export const RFIMS_ANTENNAS: Antenna[] = RFIMS_SITES.map(site => {
  const placement = RFIMS_MODEL_PLACEMENTS[site.id];
  const rooftop = placement?.support === 'roof' ? placement : undefined;
  return {
  id: site.id, name: `${site.rmsId} · ${site.name}`, shortName: `${site.rmsId} ${site.designation}`,
  network: site.name, description: rooftop ? `RFIMS on the east rooftop shelter (${site.siteId}). Approximate equipment position; original site reference retained in Site & evidence. Installed dimensions, RF pattern and mission assignments are unverified.` : `RFIMS monitoring site reference (${site.siteId}). Installed antenna dimensions, RF pattern and mission assignments are unverified.`,
  enabled: true, color: '#76e6ed',
  location: { lat: rooftop?.lat ?? site.lat, lon: rooftop?.lon ?? site.lon, name: site.location, country: 'USA' },
  capabilities: { type: 'RFIMS monitoring site', monitoringOnly: true, bands: [], uplinkCapable: false },
  coverage: {}, twin: { assetId: site.id },
  };
});
export function rfimsDataset(): NetworkDataset {
  return { network: 'rfims', missions: [], antennas: RFIMS_ANTENNAS, tiers: [], toggles: [], tdrss: [], scenarios: [], presets: [], source: 'static' };
}
